import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "window-title" }
const _hoisted_2 = { class: "rounded-xl pa-2 title" }
const _hoisted_3 = { key: 0 }

import { ref } from 'vue'
import { QuillEditor } from '@vueup/vue-quill'
import { CommonBoardItem } from '@/types/CommonBoardItem'
import { useAuthStore } from '@/stores/AuthStateStore'
import { storeToRefs } from 'pinia'

interface BoardItemModalProps {
    selectedItem: CommonBoardItem
}

interface BoardItemModalEmits {
    (e: 'on:close'): void;
    (e: 'on:update', value: CommonBoardItem): void;
    (e: 'on:delete', value: CommonBoardItem): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BoardItemModal',
  props: {
    selectedItem: {}
  },
  emits: ["on:close", "on:update", "on:delete"],
  setup(__props: any, { emit: __emit }) {

const { isSignedIn, isAdmin } = storeToRefs(useAuthStore())

const props = __props
const emits = __emit
const contentsDelta = ref(props.selectedItem.contentsDelta)


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "pa-5" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "rounded-xl window-title-container" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.selectedItem.title), 1),
            _createVNode(_component_v_btn, {
              class: "close-button",
              color: "red",
              variant: "tonal",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('on:close')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-xmark" })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_subtitle, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.selectedItem.date), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          (_ctx.selectedItem.image !== '' && _ctx.selectedItem.image !== undefined && _ctx.selectedItem.image !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_v_img, {
                  src: _ctx.selectedItem.image,
                  height: "40vh"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_unref(QuillEditor), {
            class: "mt-2",
            content: contentsDelta.value,
            "onUpdate:content": _cache[1] || (_cache[1] = ($event: any) => ((contentsDelta).value = $event)),
            options: { readOnly: true, theme: 'bubble', modules: { toolbar: false } }
          }, null, 8, ["content"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_actions, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_spacer),
          (_unref(isSignedIn) && _unref(isAdmin))
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('on:update', _ctx.selectedItem)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-edit" })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(isSignedIn) && _unref(isAdmin))
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 1,
                color: "red",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (emits('on:delete', _ctx.selectedItem)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-trash" })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})